import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { fetchStatuses } from './feedback-statuses.utils';
import { createFrozenMap } from '@/vuex/utils';
import { i18n_t as $t } from '@/utils/i18n';

export const MUTATIONS = { SET_ERROR: 'setError', SET_FETCHING: 'setFetching', SET_MAP: 'setMap' };

export const GETTERS = { LIST: 'list', NAME_BY_STATUS: 'nameByStatus' };

export const ACTIONS = { LOAD_ALL: 'loadAll' };

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        [MUTATIONS.SET_MAP] (state, { map }) {
            state.map = map;
        },
        [MUTATIONS.SET_ERROR] (state, { error }) {
            state.error = error;
        },
        [MUTATIONS.SET_FETCHING] (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async [ACTIONS.LOAD_ALL] ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            commit(MUTATIONS.SET_FETCHING, { fetching: true });
            try {
                const { data: statuses } = await fetchStatuses();

                const processedStatuses = statuses.map((status) => {
                    const processedStatus = { ...status };
                    switch (processedStatus.status) {
                        case 'new':
                            processedStatus.status_name = $t('feedbackList.status.Not Reviewed');
                            break;
                        case 'waiting':
                            processedStatus.status_name = $t('feedbackList.status.Awaiting Feedback');
                            break;
                        case 'planned':
                            processedStatus.status_name = $t('feedbackList.status.Planned');
                            break;
                        case 'developing':
                            processedStatus.status_name = $t('feedbackList.status.Building');
                            break;
                        case 'released':
                            processedStatus.status_name = $t('feedbackList.status.Released');
                            break;
                        case 'declined':
                            processedStatus.status_name = $t('feedbackList.status.Declined');
                            break;
                        default:
                            break;
                    }

                    return processedStatus;
                });

                commit(MUTATIONS.SET_MAP, {
                    map: createFrozenMap(processedStatuses, 'status'),
                });
            } catch (fetchingError) {
                commit(MUTATIONS.SET_ERROR, { error: fetchingError });
                throw fetchingError;
            }
            commit(MUTATIONS.SET_FETCHING, { fetching: false });
        },
    },
    getters: {
        [GETTERS.LIST]: (state) => values(state.map),
        [GETTERS.NAME_BY_STATUS]: (state) => (status) => get(state, `map.${status}.status_name`),
    },
};
